/**
 * @fileoverview ClubOS Settings API service — module config
 */
import apiClient from "../client";

export const settingsService = {
  /** Get all module enable/disable states for the current tenant. */
  getModules: () => apiClient.get("/settings/modules"),

  /** Save module enable/disable states. */
  saveModules: (modules) => apiClient.put("/settings/modules", { modules }),
};
